import {
    all,
    put,
    takeEvery,
    select
} from 'redux-saga/effects';

import {
    queryWatchlistApi,
    createFolderApi,
    createRootFolderApi,
} from './api';

import {
    CREATE_FOLDER_SAGA,
    QUERY_FOLDER_SAGA,
    queryFolder,
    createFolder,
    loadingFolder,
    loadedFolder,
    setAttribution,
} from './folder';
import {
    QUERY_WATCHLIST_SAGA,
    queryWatchlist,
    loadedWatchlist,
    loadingWatchlist
} from './watchlist';
import constants from '../../../../helpers/constant'
import { showToast } from '../notification';
import { modules } from 'veritone-redux-common';


const {
    config: { getConfig }
} = modules;


export function* queryFolderSaga() {
    const config = yield select(getConfig)
    yield put(loadingFolder());
    const res = yield createRootFolderApi(config.urlApi);
    if (res.error) {
        const fakeAttributionFolder = {
            id: "",
            name: "Attribute"
        }
        yield put(setAttribution(fakeAttributionFolder));
        yield put(loadedFolder());
        const toast = {
            message: "Something went wrong when create Attribute Folder in Discovery",
            action: "Dismiss",
            type: constants.FAILED
        }
        return yield put(showToast(toast));

    } 
    yield put(queryFolder(res.data.createRootFolders));
    const sharedFolder = res.data.createRootFolders.filter(({ ownerId }) => !ownerId);
    let attributionFolder = null;
    let subfolders = sharedFolder[0].subfolders || []
    subfolders.forEach(subfolder => {
        if (subfolder.name === 'Attribute') {
            attributionFolder = subfolder;
            return;
        }
    });
    if (!attributionFolder) {
        const folder = {
            name: 'Attribute',
            description: 'Folder for attribute app',
            parentFolderId: sharedFolder[0].id
        }
        const res = yield createFolderApi(config.urlApi, folder);
        attributionFolder = res.data.createFolder;
        yield put(createFolder(res.data.createFolder));
    }
    yield put(setAttribution(attributionFolder));
    yield put(loadedFolder());
}

function* createFolderSaga(folder) {
    const config = yield select(getConfig)
    const res = yield createFolderApi(config.urlApi, folder);
    yield put(createFolder(res));
    return res;
}

export function* queryWatchlistSaga() {
    const config = yield select(getConfig)
    yield put(loadingWatchlist());
    const LIMIT = 1000;
    let OFFSET = 0;
    let watchlistResult = null;
    const RETRY_MAX = 10;
    let retry = 0;
    let watchlistList = [];
    while (!watchlistResult || (watchlistResult.data.watchlists.records.length === LIMIT && retry < RETRY_MAX)) {
        watchlistResult = yield queryWatchlistApi(config.urlApi, LIMIT, OFFSET);
        OFFSET = OFFSET + LIMIT;
        retry = retry + 1;
        watchlistList = [...watchlistList, ...watchlistResult.data.watchlists.records];
    }
    yield put(queryWatchlist(watchlistList));
    yield put(loadedWatchlist());
}

export default function* mentions() {
    yield all([
        takeEvery(QUERY_FOLDER_SAGA, queryFolderSaga),
        takeEvery(CREATE_FOLDER_SAGA, createFolderSaga),
        takeEvery(QUERY_WATCHLIST_SAGA, queryWatchlistSaga),
    ]);
}
